<div class="modal-header">
  <h4 class="modal-title pull-left">Suggest Properties</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefSuggestProperties.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<form [formGroup]="suggForm" autocomplete="off" #formDir="ngForm" class="property-form" name="form">
  <div class="modal-body padding30">
    <div class="form-group">
      <label class="form-label">
        1031 Exchanges
        <span class="star">*</span>
      </label>
      <div class="select-dropdown multiselectdesign">
        <mat-form-field>
          <mat-select name="lstCharacteristic" placeholder="Select" [(ngModel)]="suggestedListing.ExchangeID" (ngModelChange)="onExchangeSelect($event);" [ngModelOptions]="{standalone: true}" multiple>
            @if (suggestedListing !=null && suggestedListing?.ExchangeID!=null&& suggestedListing?.ExchangeID.length > 1) {
            <mat-select-trigger (click)="$event.stopPropagation()">
              <span>{{ suggestedListing?.ExchangeID.length }} items selected</span>
            </mat-select-trigger>
            }
            @for (exchange of exchangeLst; track exchange) {
            <mat-option [value]="exchange.id" class="multi-dropdown-item">{{exchange.name}}</mat-option>
            }
            <mat-option class="matoptionnodata" *ngIf="exchangeLst.length === 0" disabled>
              Nothing found...
            </mat-option>
          </mat-select>
        </mat-form-field>
        <!--<angular2-multiselect formControlName="lstCharacteristic" [data]="exchangeLst" (ngModelChange)="onExchangeSelect()" [(ngModel)]="suggestedListing.ExchangeID" [settings]="defaultTypeSettings"></angular2-multiselect>-->
        <!--<mat-form-field>
          <mat-select placeholder="Select" [(ngModel)]="suggestedListing.ExchangeID" name="lstCharacteristic" (ngModelChange)="onExchangeSelect($event)" [ngModelOptions]="{standalone: true}" multiple>
            @for (exchange of exchangeLst; track exchange) {
            <mat-option [value]="exchange.id" class="multi-dropdown-item">{{exchange.name}}</mat-option>
            }
            <mat-option class="matoptionnodata" *ngIf="exchangeLst.length === 0" disabled>
              Nothing found...
            </mat-option>
          </mat-select>
        </mat-form-field>-->
      </div>
    </div>
    <div class="margin-bottom-15" style="max-height:300px;overflow-y:scroll">
      <div class="modal-data-box" *ngFor="let property of suggstedLst;let i = index" style="margin-bottom:5px;margin-right:5px">
        <button type="button" class="close pull-right" aria-label="Close" style="color:black" (click)="removeProperty(property.PropertyId,i)">
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 style="font-weight:600;">{{property.PropertyName}}</h4>
        <p>{{property.FullAddress}}</p>
        <span class="tag" [ngClass]="{'redtext':(property.PropertyStatus === 'Closed' || property.PropertyStatus === 'Sold'),
                      'greentext':property.PropertyStatus === 'Available',
                      'gerytext':property.PropertyStatus === 'Under Contract','ashtext':property.PropertyStatus === 'Off-Market'}">
          {{property.PropertyStatus}}
        </span>
      </div>
    </div>
    <div class="nodata" *ngIf="suggstedLst.length == 0">
      <i class="fa fa-exclamation-triangle icon"></i>
      <p>No Property Selected</p>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefSuggestProperties.hide()">Cancel</button>
      <button class="btn btn-success btn-lg" [disabled]="suggstedLst.length == 0" (click)="suggestList();">Suggest</button>
    </div>
  </div>
  </form>
